"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _EqualSizeFlexRowModule = _interopRequireDefault(require("./../../scss/layout-wrappers/EqualSizeFlexRow.module.scss"));
const determineItemFlex = (gap, maxItemsPerRow, childrenList) => {
  return "".concat(childrenList.length <= maxItemsPerRow ? 1 : 0, " 1 calc(").concat(childrenList.length <= maxItemsPerRow ? 100 / childrenList.length : 100 / maxItemsPerRow, "% - ").concat(gap, ")");
};
function EqualSizeFlexRow(_ref) {
  let {
    children,
    gap = '1.5rem',
    maxItemsPerRow = 4
  } = _ref;
  const childrenList = _react.Children.toArray(children);
  const itemFlex = childrenList.length === 1 ? "0 1 50%" : determineItemFlex(gap, maxItemsPerRow, childrenList);
  return /*#__PURE__*/_react.default.createElement("equal-size-flex-row", {
    style: {
      '--esfr-gap-size': gap,
      '--esfr-item-flex': itemFlex,
      '--esfr-flex-wrap': childrenList.length > maxItemsPerRow ? "wrap" : "nowrap"
    },
    "data-item-count": childrenList.length
  }, childrenList.map(child => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _EqualSizeFlexRowModule.default['equal-size-flex-row__item'],
      key: "esfr-".concat(Math.round(Math.random() * 10000000))
    }, /*#__PURE__*/(0, _react.cloneElement)(child, child.props));
  }));
}
var _default = exports.default = EqualSizeFlexRow;